// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.footer[data-v-001546c0] .jumbo__background {
      --tw-bg-opacity: 1;
      background-color: rgb(16 33 62 / var(--tw-bg-opacity));
}
.footer__logo[data-v-001546c0] {
      width: 12rem;
}
.footer__nav[data-v-001546c0] .jumbo__content {
      flex-direction: column;
      gap: 3rem;
      padding-top: 3.5rem;
      padding-bottom: 3.5rem;
}
@media (min-width: 768px) {
.footer__nav[data-v-001546c0] .jumbo__content {
            justify-content: space-between;
}
}
@media (min-width: 996px) {
.footer__nav[data-v-001546c0] .jumbo__content {
            flex-direction: row;
            align-items: flex-start;
            padding-top: 4.5rem;
            padding-bottom: 4.5rem;
            padding-left: 2.5rem;
            padding-right: 2.5rem;
}
}
@media (min-width: 1320px) {
.footer__nav[data-v-001546c0] .jumbo__content {
            padding-left: 7.5rem;
            padding-right: 7.5rem;
}
}
@media (min-width: 1536px) {
.footer__nav[data-v-001546c0] .jumbo__content {
            padding-left: 13.5rem;
            padding-right: 13.5rem;
}
}
.footer__navigation[data-v-001546c0] {
      display: flex;
      flex-direction: column;
      gap: 1rem;
}
@media (min-width: 996px) {
.footer__navigation[data-v-001546c0] {
            flex-direction: row;
            gap: 5rem;
}
}
.footer__navigation ul[data-v-001546c0] > :not([hidden]) ~ :not([hidden]) {
      --tw-space-y-reverse: 0;
      margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
      margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.footer__link[data-v-001546c0] {
      text-align: center;
      --tw-text-opacity: 1;
      color: rgb(255 255 255 / var(--tw-text-opacity));
}
@media (min-width: 996px) {
.footer__link[data-v-001546c0] {
            text-align: left;
}
}
.footer__link[data-v-001546c0]:last-child {
      grid-column: 2;
}
.footer__legal[data-v-001546c0] {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
}
@media (min-width: 996px) {
.footer__legal[data-v-001546c0] {
            flex-direction: row-reverse;
            justify-content: space-between;
}
}
.footer__legal ul[data-v-001546c0] {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
      --tw-text-opacity: 1;
      color: rgb(167 178 196 / var(--tw-text-opacity));
      font-family: Roboto;
      line-height: 1.5;
      font-size: 0.875rem;
      font-weight: 400;
}
@media (min-width: 996px) {
.footer__legal ul[data-v-001546c0] {
            flex-direction: row;
            justify-content: space-between;
            gap: 2.25rem;
}
}
.footer__legal[data-v-001546c0] .jumbo__content {
      margin-top: 0;
      margin-bottom: 0;
      flex-direction: column-reverse;
      gap: 1rem;
      border-top-width: 1px;
      --tw-border-opacity: 1;
      border-color: rgb(71 90 125 / var(--tw-border-opacity));
      padding-top: 3rem;
      padding-bottom: 3rem;
      padding-left: 0;
      padding-right: 0;
}
@media (min-width: 768px) {
.footer__legal[data-v-001546c0] .jumbo__content {
            justify-content: space-between;
}
}
@media (min-width: 996px) {
.footer__legal[data-v-001546c0] .jumbo__content {
            margin-left: 2.5rem;
            margin-right: 2.5rem;
            flex-direction: row;
            padding-top: 1.5rem;
            padding-bottom: 1.5rem;
}
}
@media (min-width: 1320px) {
.footer__legal[data-v-001546c0] .jumbo__content {
            margin-left: 4rem;
            margin-right: 4rem;
}
}
@media (min-width: 1536px) {
.footer__legal[data-v-001546c0] .jumbo__content {
            margin-left: 13.5rem;
            margin-right: 13.5rem;
}
}
.footer__copyright[data-v-001546c0] {
      --tw-text-opacity: 1;
      color: rgb(71 90 125 / var(--tw-text-opacity));
      font-family: Roboto;
      line-height: 1.5;
      font-size: 1rem;
      font-weight: 400;
}
.footer__externals[data-v-001546c0] {
      width: 100%;
}
.footer__externals[data-v-001546c0] .jumbo__content {
      flex-direction: column;
      gap: 3rem;
      padding-top: 3.5rem;
      padding-bottom: 3.5rem;
}
@media (min-width: 768px) {
.footer__externals[data-v-001546c0] .jumbo__content {
            justify-content: space-between;
}
}
@media (min-width: 996px) {
.footer__externals[data-v-001546c0] .jumbo__content {
            flex-direction: row;
            align-items: flex-start;
            padding-top: 4.5rem;
            padding-bottom: 4.5rem;
            padding-left: 2.5rem;
            padding-right: 2.5rem;
}
}
@media (min-width: 1320px) {
.footer__externals[data-v-001546c0] .jumbo__content {
            padding-left: 7.5rem;
            padding-right: 7.5rem;
}
}
@media (min-width: 1536px) {
.footer__externals[data-v-001546c0] .jumbo__content {
            padding-left: 13.5rem;
            padding-right: 13.5rem;
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/Footer.vue"],"names":[],"mappings":";AA4FA;MAAA,kBAAA;MAAA,sDAAA;AAAA;AAIA;MAAA,YAAA;AAAA;AAKA;MAAA,sBAAA;MAAA,SAAA;MAAA,mBAAA;MAAA,sBAAA;AAAA;AAAA;AAAA;YAAA,8BAAA;AAAA;AAAA;AAAA;AAAA;YAAA,mBAAA;YAAA,uBAAA;YAAA,mBAAA;YAAA,sBAAA;YAAA,oBAAA;YAAA,qBAAA;AAAA;AAAA;AAAA;AAAA;YAAA,oBAAA;YAAA,qBAAA;AAAA;AAAA;AAAA;AAAA;YAAA,qBAAA;YAAA,sBAAA;AAAA;AAAA;AAKA;MAAA,aAAA;MAAA,sBAAA;MAAA,SAAA;AAAA;AAAA;AAAA;YAAA,mBAAA;YAAA,SAAA;AAAA;AAAA;AAGA;MAAA,uBAAA;MAAA,4DAAA;MAAA,qDAAA;AAAA;AAKA;MAAA,kBAAA;MAAA,oBAAA;MAAA,gDAAA;AAAA;AAAA;AAAA;YAAA,gBAAA;AAAA;AAAA;AAEA;MACA,cAAA;AACA;AAIA;MAAA,aAAA;MAAA,WAAA;MAAA,sBAAA;MAAA,mBAAA;AAAA;AAAA;AAAA;YAAA,2BAAA;YAAA,8BAAA;AAAA;AAAA;AAGA;MAAA,aAAA;MAAA,sBAAA;MAAA,mBAAA;MAAA,WAAA;MAAA,oBAAA;MAAA,gDAAA;MAAA,mBAAA;MAAA,gBAAA;MAAA,mBAAA;MAAA,gBAAA;AAAA;AAAA;AAAA;YAAA,mBAAA;YAAA,8BAAA;YAAA,YAAA;AAAA;AAAA;AAIA;MAAA,aAAA;MAAA,gBAAA;MAAA,8BAAA;MAAA,SAAA;MAAA,qBAAA;MAAA,sBAAA;MAAA,uDAAA;MAAA,iBAAA;MAAA,oBAAA;MAAA,eAAA;MAAA,gBAAA;AAAA;AAAA;AAAA;YAAA,8BAAA;AAAA;AAAA;AAAA;AAAA;YAAA,mBAAA;YAAA,oBAAA;YAAA,mBAAA;YAAA,mBAAA;YAAA,sBAAA;AAAA;AAAA;AAAA;AAAA;YAAA,iBAAA;YAAA,kBAAA;AAAA;AAAA;AAAA;AAAA;YAAA,oBAAA;YAAA,qBAAA;AAAA;AAAA;AAKA;MAAA,oBAAA;MAAA,8CAAA;MAAA,mBAAA;MAAA,gBAAA;MAAA,eAAA;MAAA,gBAAA;AAAA;AAIA;MAAA,WAAA;AAAA;AAGA;MAAA,sBAAA;MAAA,SAAA;MAAA,mBAAA;MAAA,sBAAA;AAAA;AAAA;AAAA;YAAA,8BAAA;AAAA;AAAA;AAAA;AAAA;YAAA,mBAAA;YAAA,uBAAA;YAAA,mBAAA;YAAA,sBAAA;YAAA,oBAAA;YAAA,qBAAA;AAAA;AAAA;AAAA;AAAA;YAAA,oBAAA;YAAA,qBAAA;AAAA;AAAA;AAAA;AAAA;YAAA,qBAAA;YAAA,sBAAA;AAAA;AAAA","sourcesContent":["<template>\n  <footer class=\"footer\">\n    <Jumbo class=\"footer__nav\" size=\"fit\">\n      <template #background></template>\n\n      <template #before>\n        <a href=\"/\"><Logo white class=\"footer__logo\"/></a>\n      </template>\n\n      <template #after>\n        <div class=\"footer__navigation\">\n          <nav v-for=\"(item, index) in elements\" :key=\"index\">\n            <ul>\n              <li v-for=\"(val, key) in item\" :key=\"key\" class=\"footer__link\">\n                <a :href=\"val\">{{ key }}</a>\n              </li>\n            </ul>\n          </nav>\n        </div>\n      </template>\n    </Jumbo>\n\n    <Jumbo size=\"fit\" class=\"footer__externals\" reverseOnMobile>\n      <template #before>\n        <Entities />\n      </template>\n      <template #after>\n        <SocialLinks />\n      </template>\n    </Jumbo>\n\n    <Jumbo class=\"footer__legal\" size=\"fit\" reverseOnMobile>\n      <template #background></template>\n\n      <template #before>\n        <p class=\"footer__copyright\">© {{ year }} Trioteca</p>\n      </template>\n\n      <template #after>\n        <nav aria-label=\"Asuntos legales\">\n          <ul>\n            <li><a href=\"/legal/politica-de-privacidad\">Política de privacidad</a></li>\n            <li><a href=\"/legal/aviso-legal-y-condiciones-generales\">Términos y condiciones</a></li>\n            <li><a href=\"/legal/politica-de-cookies\">Política de cookies</a></li>\n            <li><a href=\"#cookies-manager\" @click.prevent=\"openCookiesManager\">Configurar cookies</a></li>\n          </ul>\n        </nav>\n      </template>\n    </Jumbo>\n  </footer>\n</template>\n\n<script>\nimport Jumbo from '@/lego/components/layout/Jumbo.vue';\nimport Icon from '@/lego/components/icons/Icon.vue';\nimport Entities from '@/lego/partials/Entities.vue';\nimport SocialLinks from '@/lego/partials/SocialLinks.vue';\nimport route from '@/route.js';\nimport Logo from '@/lego/components/layout/Logo.vue';\nimport CookiesBus from '@/lego/utils/bus/cookies';\n\nexport default {\n  components: {\n    Jumbo,\n    Icon,\n    Entities,\n    SocialLinks,\n    Logo,\n  },\n  setup() {\n    return {\n      elements: [\n        { Glosario: route('help.glossary'), 'Preguntas frecuentes': route('help.faqs'), 'Trabaja con nosotros': route('about') },\n\n        {\n          'Simular una nueva hipoteca': route('new-mortgage-page.index'),\n          'Mejorar mi hipoteca actual': route('funnel.improve'),\n          'Tasación oficial': route('official-appraisal.view'),\n        },\n      ],\n      year: new Date().getFullYear(),\n      openCookiesManager: () => {\n        CookiesBus.emit('manager.open');\n      },\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.footer {\n  /deep/.jumbo__background {\n    @apply bg-brand-secondary-dark;\n  }\n\n  &__logo {\n    @apply w-[12rem];\n  }\n\n  &__nav {\n    /deep/.jumbo__content {\n      @apply lg:items-start py-lg lg:py-[4.5rem] md:justify-between flex-col lg:flex-row gap-md 2xl:px-[13.5rem] xl:px-[7.5rem] lg:px-sm;\n    }\n  }\n\n  &__navigation {\n    @apply flex lg:flex-row lg:gap-xxl gap-xxxs flex-col;\n\n    ul {\n      @apply space-y-xxxs;\n    }\n  }\n\n  &__link {\n    @apply text-neutral-white lg:text-left text-center;\n\n    &:last-child {\n      grid-column: 2;\n    }\n  }\n\n  &__legal {\n    @apply flex flex-col lg:flex-row-reverse items-center lg:justify-between w-full;\n\n    ul {\n      @apply flex flex-col lg:flex-row lg:justify-between items-center style-overline text-neutral-grayish lg:gap-[2.25rem] gap-nano;\n    }\n\n    /deep/.jumbo__content {\n      @apply 2xl:mx-[13.5rem] xl:mx-xl lg:mx-sm py-md lg:py-xxs my-0 flex-col-reverse md:justify-between lg:flex-row border-t-hairline border-brand-secondary-lightest px-0 gap-xxxs;\n    }\n  }\n\n  &__copyright {\n    @apply style-body-sm text-brand-secondary-lightest;\n  }\n\n  &__externals {\n    @apply w-full;\n\n    /deep/.jumbo__content {\n      @apply lg:items-start py-lg lg:py-[4.5rem] md:justify-between flex-col lg:flex-row gap-md 2xl:px-[13.5rem] xl:px-[7.5rem] lg:px-sm;\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
